import { Star } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface TestimonialCardProps {
  authorName: string;
  testimonialText: string;
  rating: number;
  authorRole?: string | null;
  authorPhotoUrl?: string | null;
}

export function TestimonialCard({
  authorName,
  testimonialText,
  rating,
  authorRole,
  authorPhotoUrl,
}: TestimonialCardProps) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 h-full flex flex-col p-6 relative overflow-hidden">
      {/* Accent top border */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-primary to-brand-brightGreen rounded-t-2xl" />

      {/* Large quote mark */}
      <span className="title-special text-7xl text-brand-primary/10 leading-none select-none absolute top-4 right-5">
        "
      </span>

      {/* Stars */}
      <div className="flex gap-0.5 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className={`w-4 h-4 ${i < rating ? "text-yellow-400 fill-current" : "text-gray-200"}`}
          />
        ))}
      </div>

      {/* Text */}
      <p className="text-gray-600 flex-1 leading-relaxed mb-6 font-primary font-light text-sm italic relative z-10">
        "{testimonialText}"
      </p>

      {/* Author */}
      <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
        <Avatar className="h-10 w-10 border-2 border-brand-primary/20">
          <AvatarImage src={authorPhotoUrl || undefined} alt={authorName} />
          <AvatarFallback className="bg-brand-primary/10 text-brand-primary text-sm font-bold font-primary">
            {authorName.charAt(0)}
          </AvatarFallback>
        </Avatar>
        <div className="flex-1">
          <p className="font-bold text-gray-800 text-sm font-primary">{authorName}</p>
          {authorRole && (
            <p className="text-xs text-gray-400 font-primary">{authorRole}</p>
          )}
        </div>
      </div>
    </div>
  );
}
